import React from 'react';
import { Award, Users, Briefcase, Code2, ExternalLink } from 'lucide-react';
import './Trust.css';

const techStackData = [
  'Laravel', 'PHP', 'HTML', 'CSS', 'JavaScript', 'Livewire',
  'Vue.js', 'jQuery', 'Bootstrap', 'Toasty', 'MySQL', 'PostgreSQL', 'Redis'
];

const clientsData = [
  {
    name: 'Rank Brew',
    logo: 'https://whitelabeldevs.com/cdn/rankbrew.svg'
  },
  {
    name: 'SerpFit',
    logo: 'https://whitelabeldevs.com/cdn/serpfit.png'
  },
  {
    name: 'Vrishbha Visuals LLP',
    logo: 'https://whitelabeldevs.com/cdn/vrishaba.png'
  }
];

const caseStudiesData = [
  {
    title: 'Fabric Management System',
    description: 'Complete inventory and warehouse management solution for fabric businesses with real-time tracking and analytics.',
    image: 'https://whitelabeldevs.com/portfolio/fabric.png',
    tags: ['Laravel', 'Inventory', 'Analytics']
  },
  {
    title: 'Learning Management System',
    description: 'Feature-rich educational platform with class scheduling, timetables, and comprehensive student management.',
    image: 'https://whitelabeldevs.com/portfolio/lms.png',
    tags: ['Laravel', 'Education', 'Scheduling']
  },
  {
    title: 'Advocate Management System',
    description: 'Professional case management system for law firms with client tracking, case history, and document management.',
    image: 'https://whitelabeldevs.com/portfolio/advocate.png',
    tags: ['Laravel', 'Legal', 'CRM']
  }
];

const Trust = () => {
  return (
    <section className="trust-section">
      <div className="trust-container">
        <div className="trust-header">
          <h2 className="section-title">Trust & Experience</h2>
          <p className="section-description">
            Proven track record with agencies and businesses worldwide
          </p>
        </div>
        
        <div className="trust-content">
          <div className="founder-card">
            <div className="founder-icon">
              <Award size={48} />
            </div>
            <h3 className="founder-title">Aditya Rathore</h3>
            <p className="founder-subtitle">Founder | 12+ Years in Web Development</p>
            <p className="founder-description">
              Senior AI Powered PHP & Laravel Developer with proven track record in building SaaS systems, 
              automation platforms, business portals, and agency projects.
            </p>
            <div className="founder-expertise">
              <div className="expertise-item">
                <Code2 size={24} />
                <span>AI, Laravel & PHP Expert</span>
              </div>
              <div className="expertise-item">
                <Briefcase size={24} />
                <span>White-Label Specialist</span>
              </div>
              <div className="expertise-item">
                <Users size={24} />
                <span>Long-term Partnerships</span>
              </div>
            </div>
          </div>
          
          <div className="trust-details">
            <div className="tech-stack-section">
              <h3 className="subsection-title">Technology Stack</h3>
              <div className="tech-stack-grid">
                {techStackData.map((tech, index) => (
                  <div key={index} className="tech-badge">
                    {tech}
                  </div>
                ))}
              </div>
            </div>
            
            <div className="clients-section">
              <h3 className="subsection-title">Trusted By</h3>
              <div className="clients-logo-grid">
                {clientsData.map((client, index) => (
                  <div key={index} className="client-logo-card">
                    <img
                      src={client.logo}
                      alt={client.name}
                      className={`client-logo ${client.name === 'Rank Brew' ? 'client-logo-rankbrew' : ''}`}
                    />
                  </div>
                ))}
              </div>
            </div>
            
            <div className="commitment-section">
              <div className="commitment-badge">
                <Award size={24} />
                <div>
                  <strong>Long-term partnerships, not one-off gigs</strong>
                  <p>Emphasis on reliable, scalable collaboration and ongoing support</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Case Studies Section */}
        <div className="case-studies-section">
          <div className="case-studies-header">
            <h2 className="section-title">Case Studies</h2>
            <p className="section-description">
              Real-world Laravel solutions built for diverse industries
            </p>
          </div>
          
          <div className="case-studies-grid">
            {caseStudiesData.map((study, index) => (
              <div key={index} className="case-study-card">
                <div className="case-study-image-wrapper">
                  <img src={study.image} alt={study.title} className="case-study-image" />
                  <div className="case-study-overlay">
                    <ExternalLink size={24} />
                  </div>
                </div>
                <div className="case-study-content">
                  <h3 className="case-study-title">{study.title}</h3>
                  <p className="case-study-description">{study.description}</p>
                  <div className="case-study-tags">
                    {study.tags.map((tag, idx) => (
                      <span key={idx} className="case-study-tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trust;